import { KyuLevel } from '../types';

export const kyuLevels: (KyuLevel | undefined)[] = [
    undefined, // Index 0 - unused
    // Index 1 = 1st Kyu
    {
        level: '1st Kyu', operations: ['addition', 'subtraction', 'multiplication', 'division'],
        addSubDigits1: 8, addSubDigits2: 8,
        mulDigits: { multiplicand: [5, 7], multiplier: [4, 6], maxCombined: 11 },
        divDigits: { dividend: [8, 12], divisor: [4, 6], maxCombined: 10 },
        problemCount: 60, operationCounts: { addition: 20, subtraction: 10, multiplication: 20, division: 10 }
    },
    // Index 2 = 2nd Kyu
    {
        level: '2nd Kyu', operations: ['addition', 'subtraction', 'multiplication', 'division'],
        addSubDigits1: 7, addSubDigits2: 7,
        mulDigits: { multiplicand: [4, 6], multiplier: [3, 5], maxCombined: 9 },
        divDigits: { dividend: [6, 10], divisor: [3, 5], maxCombined: 8 },
        problemCount: 60, operationCounts: { addition: 20, subtraction: 10, multiplication: 20, division: 10 }
    },
    // Index 3 = 3rd Kyu
    {
        level: '3rd Kyu', operations: ['addition', 'subtraction', 'multiplication', 'division'],
        addSubDigits1: 6, addSubDigits2: 6,
        mulDigits: { multiplicand: [3, 5], multiplier: [2, 4], maxCombined: 7 },
        divDigits: { dividend: [4, 8], divisor: [2, 4], maxCombined: 6 },
        problemCount: 60, operationCounts: { addition: 20, subtraction: 10, multiplication: 20, division: 10 }
    },
    // Index 4 = 4th Kyu
    {
        level: '4th Kyu', operations: ['addition', 'subtraction', 'multiplication', 'division'],
        addSubDigits1: 5, addSubDigits2: 5,
        mulDigits: { multiplicand: [3, 5], multiplier: [2, 4], maxCombined: 7 },
        divDigits: { dividend: [4, 8], divisor: [2, 4], maxCombined: 6 },
        problemCount: 60, operationCounts: { addition: 20, subtraction: 10, multiplication: 20, division: 10 }
    },
    // Index 5 = 5th Kyu
    {
        level: '5th Kyu', operations: ['addition', 'subtraction', 'multiplication', 'division'],
        addSubDigits1: 5, addSubDigits2: 5,
        mulDigits: { multiplicand: [2, 4], multiplier: [2, 4], maxCombined: 6 },
        divDigits: { dividend: [3, 6], divisor: [1, 4], maxCombined: 5 },
        problemCount: 60, operationCounts: { addition: 20, subtraction: 10, multiplication: 20, division: 10 }
    },
    // Index 6 = 6th Kyu
    {
        level: '6th Kyu', operations: ['addition', 'subtraction', 'multiplication', 'division'],
        addSubDigits1: 4, addSubDigits2: 4,
        mulDigits: { multiplicand: [2, 3], multiplier: [2, 3], maxCombined: 5 },
        divDigits: { dividend: [3, 5], divisor: [1, 3], maxCombined: 4 },
        problemCount: 60, operationCounts: { addition: 20, subtraction: 10, multiplication: 20, division: 10 }
    },
    // Index 7 = 7th Kyu
    {
        level: '7th Kyu', operations: ['addition', 'subtraction', 'multiplication', 'division'],
        addSubDigits1: 4, addSubDigits2: 4,
        mulDigits: { multiplicand: [1, 3], multiplier: [1, 3], maxCombined: 4 },
        divDigits: { dividend: [2, 4], divisor: [1, 3], maxCombined: 4 },
        problemCount: 50, operationCounts: { addition: 20, subtraction: 10, multiplication: 15, division: 5 }
    },
    // Index 8 = 8th Kyu
    {
        level: '8th Kyu', operations: ['addition', 'subtraction', 'multiplication', 'division'],
        addSubDigits1: 3, addSubDigits2: 3,
        mulDigits: { multiplicand: [1, 3], multiplier: [1, 3], maxCombined: 4 },
        divDigits: { dividend: [2, 4], divisor: [1, 3], maxCombined: 4 },
        problemCount: 50, operationCounts: { addition: 20, subtraction: 10, multiplication: 15, division: 5 }
    },
    // Index 9 = 9th Kyu
    {
        level: '9th Kyu', operations: ['addition', 'subtraction', 'multiplication'],
        addSubDigits1: 3, addSubDigits2: 3,
        mulDigits: { multiplicand: [2, 2], multiplier: [1, 1], maxCombined: 3 },
        problemCount: 40, operationCounts: { addition: 20, subtraction: 10, multiplication: 10 }
    },
    // Index 10 = 10th Kyu
    { level: '10th Kyu', operations: ['addition', 'subtraction'], addSubDigits1: 3, addSubDigits2: 3, problemCount: 30, operationCounts: { addition: 20, subtraction: 10 } },
    // Index 11 = 11th Kyu
    { level: '11th Kyu', operations: ['addition', 'subtraction'], addSubDigits1: 2, addSubDigits2: 2, problemCount: 20, operationCounts: { addition: 15, subtraction: 5 } },
    // Index 12 = 12th Kyu
    { level: '12th Kyu', operations: ['addition', 'subtraction'], addSubDigits1: 2, addSubDigits2: 2, problemCount: 20, operationCounts: { addition: 15, subtraction: 5 } },
    // Index 13 = 13th Kyu
    { level: '13th Kyu', operations: ['addition', 'subtraction'], addSubDigits1: 2, addSubDigits2: 1, problemCount: 15, operationCounts: { addition: 10, subtraction: 5 } },
    // Index 14 = 14th Kyu
    { level: '14th Kyu', operations: ['addition', 'subtraction'], addSubDigits1: 1, addSubDigits2: 1, problemCount: 15, operationCounts: { addition: 10, subtraction: 5 } },
    // Index 15 = 15th Kyu
    { level: '15th Kyu', operations: ['addition'], addSubDigits1: 1, addSubDigits2: 1, problemCount: 10, operationCounts: { addition: 10 } },
];
